import { getCurrentTenant, subscribeTenantStateChange } from '@/commons';
import c from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './style.module.less';

interface Props {
  collapsed?: boolean;
  className?: string;
  theme?: 'light' | 'dark';
}

export function Logo(props: Props) {
  const { className, collapsed, theme = 'dark', ...others } = props;
  const navigate = useNavigate();
  const [tenant, setTenant] = useState(() => getCurrentTenant());

  useEffect(() => {
    return subscribeTenantStateChange(() => setTenant(getCurrentTenant()));
  }, []);

  const logo = tenant?.logo || '/logo.svg';
  const appName = tenant?.name || '平台';

  return (
    <h1
      className={c(s.root, collapsed && s.collapsed, s[theme], className)}
      onClick={() => navigate('/')}
      {...others}
    >
      <img src={logo} alt="Logo" className={s.logo} />
      {collapsed ? null : (
        <span className={s.name} title={appName}>
          {appName}
        </span>
      )}
    </h1>
  );
}
